module.exports = __webpack_public_path__ + "img/footer_logo.3798c1e7.png";